import {createTheme} from "@mui/material/styles";

const commonTypography = {
    fontFamily: [
        'Figtree', // Referenced in index.css
        'Roboto',
        'Helvetica Neue',
        'Arial',
        'sans-serif',
    ].join(','),
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
}

const lightTheme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#1C4481",
            light: "#1961B1",
            dark: "#152D51",
            background: "#F5F5F5",
            componentbg: "#FFFFFF",
        },
        success: {
            main: "#2E7D32",
        },
        error: {
            main: "#D13A10",
        },
        warning: {
            main: "#FBAB00",
        },
        black: "#212121",
        white: "#FFFFFF",
        blue: {
            oxford: "#181E35",
            yale: "#0F3E6F",
            azure: "#157EE0"
        },
        gray: {
            main: "#BDBDBD",
            light: "#E0E0E0",
            dark: "#616161",
            graph: "#616161",
        },
        accent: {
            success: "#2E7D32", // MUI Success
            error: "#D13A10",
            green: "#003D34",
            orange: "#FBAB00",
            safetyorange: "#E67308",
        },
    },
    typography: commonTypography
});

const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: "#157EE0",
            light: "#1961B1",
            dark: "#152D51",
            componentbg: "#212121",
            background: "#121212",
        },
        success: {
            main: "#2E7D32",
        },
        error: {
            main: "#D13A10",
        },
        warning: {
            main: "#FBAB00",
        },
        black: "#212121",
        white: "#FFFFFF",
        blue: {
            oxford: "#181E35",
            yale: "#0F3E6F",
            azure: "#157EE0"
        },
        gray: {
            main: "#BDBDBD",
            light: "#E0E0E0",
            dark: "#616161",
            graph: "#E0E0E0",
        },
        accent: {
            success: "#2E7D32", // MUI Success
            error: "#D13A10",
            green: "#003D34",
            orange: "#FBAB00",
            safetyorange: "#E67308",
        },
    },
    typography: commonTypography
});

export const getTheme = (mode) => createTheme(mode === "light" ? lightTheme : darkTheme);